import {useDebugValue} from 'react';

function useEdapProvider(searchFormContext) {
    const {
        edapOptions: {
            searchSubmitEventName,
            searchSubmitEventActionLocation,
            datedSearchSubmitEventName,
            searchQuerySubmittedEventName,
            searchQuerySubmittedEventActionLocation
        }
    } = searchFormContext;

    const fields = {};

    const options = {};

    const eventFields = {
        [searchSubmitEventName]: {
            action_location: searchSubmitEventActionLocation
        },
        [datedSearchSubmitEventName]: {
            action_location: searchSubmitEventActionLocation
        },
        [searchQuerySubmittedEventName]: {
            action_location: searchQuerySubmittedEventActionLocation
        }
    };

    const eventOptions = {};

    const result = {
        fields,
        options,
        eventFields,
        eventOptions
    };

    useDebugValue(result);

    return result;
}

export {useEdapProvider};
